import axios from "axios";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      store_closeout_purchases: "MaxTerm/getCloseoutPurchases",
      store_closeout_purchase_ids: "MaxTerm/getCloseoutPurchaseIds",
      store_refresh_trigger: "MaxTerm/getRefreshTrigger",
    }),
  },
  data: function () {
    return {
      closeout_purchase_ids: [],
      closeout_purchases: [],
      closeout_group_ids: [], //for nlis page
      nlisPayoutData: [], // for nlis page
      closeout_business: null,
      closeout_livestock_class_id: null,
      invoice_type_id: null,
      animals_sold: false,
      payoutModalShow: false,
      refinanceModalShow: false,
      valuesToRefinanceModalShow: false,
      updateTermModalShow: false,
      closeoutStatuses: {
        pending: {
          id: 1,
          name: "Pending",
          class: "status-badge pending fa-sm",
        },
        reopen: {
          id: 3,
          name: "Reopen",
          tag_type: "secondary",
          class: "status-badge paid fa-sm",
        },
        approved: {
          id: 2,
          name: "Approved",
          tag_type: "success",
          class: "status-badge approved fa-sm",
        },
      },
    };
  },
  methods: {
    purchasesExpiredMT() {
      let result = false;
      if (this.store_closeout_purchases.length > 0) {
        this.store_closeout_purchases.forEach((purchase) => {
          let days = this.getDaysUntilExpiryMT(purchase.invoice_due_date, true);
          if (days <= 0) {
            result = true;
          }
        });
      }
      return result;
    },
    closeModalMT() {
      this.payoutModalShow = false;
      this.refinanceModalShow = false;
      this.valuesToRefinanceModalShow = false;
      this.invoice_type_id = null;
      if (this.store_closeout_purchase_ids.length == 0) {
        this.clearCloseoutMT();
      }
    },
    refreshMT() {
      this.clearCloseoutMT();
    },
    clearCloseoutMT() {
      /*this.refinanceModalShow = false;
      this.payoutModalShow = false;
      this.valuesToRefinanceModalShow = false;*/
      this.closeout_business = null;
      this.closeout_livestock_class_id = null;
      this.closeout_purchases = [];
      this.closeout_purchase_ids = [];
      this.invoice_type_id = null;
      this.animals_sold = false;
      this.nlisPayoutData = [];
      this.closeout_group_ids = [];
      this.$store.dispatch("MaxTerm/clearCloseoutPurchases");
    },
    getCloseoutStatusMT(status_id) {
      let self = this;
      let statuses = Object.keys(self.closeoutStatuses).map((key) => {
        return self.closeoutStatuses[key];
      });

      let status = statuses.find((x) => x.id == status_id);
      return status.class;
    },
    getActionTypeMT(date) {
      let days = 0;
      if (date)
        days = moment(moment(date).startOf("day")).diff(
          moment(moment().startOf("day")),
          "days"
        );

      if (days <= 7) {
        return "alert-danger";
      } else {
        return "alert-warning";
      }
    },
    getActionMT(date) {
      let days = 0;
      if (date)
        days = moment(moment(date).startOf("day")).diff(
          moment(moment().startOf("day")),
          "days"
        );

      if (days <= 7) {
        return "Urgent";
      } else {
        return "Requires Action";
      }
    },
    validateBusinessMT(purchase) {
      if (
        this.store_closeout_purchase_ids.length > 0 &&
        this.closeout_business
      ) {
        if (
          purchase.business_id != this.closeout_business.id ||
          purchase.livestock_class_id != this.closeout_livestock_class_id
        )
          return true;
      }
      if (
        purchase.latest_balance_batch &&
        purchase.latest_balance_batch.status != 2
      ) {
        return true;
      }
      return false;
    },
    getPurchaseDataMT(purchase) {
      return {
        id: purchase.id,
        ref_id: purchase.ref_id,
        off_pic: purchase.purchase_assets_open_off_pic_count,
        on_pic:
          purchase.open_heads - purchase.purchase_assets_open_off_pic_count,
        open_head: purchase.open_heads,
        invoice_due_date: purchase.invoice_due_date,
        average_weight: purchase.average_weight,
        term: purchase.term,
        invoice_invoice_date: purchase.invoice_invoice_date,
        business_id: purchase.business_id,
        agency_id: purchase.agency_id,
      };
    },
    removePurchaseMT(purchaseId) {
      if (this.closeout_purchases.length > 0) {
        this.closeout_purchases = this.closeout_purchases.filter(
          (p) => p.id != purchaseId
        );
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchases",
          this.store_closeout_purchases.filter((p) => p.id != purchaseId)
        );
      }
      if (this.store_closeout_purchase_ids.length > 0) {
        this.closeout_purchase_ids = this.closeout_purchase_ids.filter(
          (id) => id != purchaseId
        );
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchaseIds",
          this.store_closeout_purchase_ids.filter((id) => id != purchaseId)
        );
      }
    },
    selectBusinessMT(val, purchase) {
      if (this.store_closeout_purchase_ids.length == 1 && val.target.checked) {
        this.closeout_purchases = [];
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchases",
          this.closeout_purchases
        );
      }
      if (val.target.checked && !this.closeout_business) {
        this.closeout_business = purchase.business;
        this.closeout_livestock_class_id = purchase.livestock_class_id;
      }

      if (val.target.checked) {
        let purchaseData = this.getPurchaseDataMT(purchase);
        this.closeout_purchases.push(purchaseData);
        this.$store.dispatch("MaxTerm/updateCloseoutPurchases", [
          ...this.store_closeout_purchases,
          purchaseData,
        ]);
        this.$store.dispatch("MaxTerm/updateCloseoutPurchaseIds", [
          ...this.store_closeout_purchase_ids,
          purchase.id,
        ]);
      } else {
        this.closeout_purchases = this.closeout_purchases.filter(
          (p) => p.id != purchase.id
        );
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchases",
          this.store_closeout_purchases.filter((p) => p.id != purchase.id)
        );
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchaseIds",
          this.store_closeout_purchase_ids.filter((id) => id != purchase.id)
        );
      }

      if (this.store_closeout_purchase_ids.length == 0) {
        this.clearCloseoutMT();
      }
    },
    valuesToRefinanceCloseoutMT() {
      this.valuesToRefinanceModalShow = true;
    },
    refinanceCloseoutMT() {
      let total_off_pic = this.closeout_purchases.reduce(
        (prev, curr) => prev + Number(curr.off_pic),
        0
      );
      let open_head = this.closeout_purchases.reduce(
        (prev, curr) => prev + Number(curr.open_head),
        0
      );
      if (total_off_pic > 0) {
        let message = "One or more of the selected trades";
        if (this.closeout_purchases.length == 1) {
          message = "The selected trade";
        }
        Swal.fire({
          title: "Refinance",
          text: `${message} has animals off PIC. Off PIC Animals cannot be refinanced. Please confirm off PIC animals will be paid out at settlement. Alternatively, please contact our office to arrange NLIS access to PIC`,
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          cancelButtonColor: "#F56C6C",
          confirmButtonColor: "#2EADBB",
          allowOutsideClick: true,
          showCloseButton: true,
        })
          .then(async (result) => {
            if (result.value) {
              if (open_head == total_off_pic) {
                this.payoutModalShow = true;
                this.invoice_type_id = 2;
              } else {
                this.refinanceModalShow = true;
              }
            }

            if (result.dismiss == "cancel") this.invoice_type_id = null;
          })
          .catch(() => {
            this.invoice_type_id = null;
          });
      } else {
        this.refinanceModalShow = true;
      }
    },
    payoutCloseoutMT() {
      Swal.fire({
        title: "Payout",
        text: "Have animals been sold?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonColor: "#F56C6C",
        confirmButtonColor: "#2EADBB",
        allowOutsideClick: true,
        showCloseButton: true,
      })
        .then(async (result) => {
          if (!result.value && result.dismiss != "cancel") {
            this.invoice_type_id = null;
          } else {
            if (result.value) this.animals_sold = true;
            if (result.dismiss == "cancel") this.animals_sold = false;

            this.payoutModalShow = true;
          }
        })
        .catch(() => {
          this.invoice_type_id = null;
        });
    },
    closeoutPurchaseMT(command, purchase = null) {
      if (purchase) {
        let purchaseData = this.getPurchaseDataMT(purchase);
        this.closeout_purchases = [purchaseData];
        this.$store.dispatch(
          "MaxTerm/updateCloseoutPurchases",
          this.closeout_purchases
        );
        // this.store_closeout_purchase_ids = [purchase.id];
        this.closeout_business = purchase.business;
        this.closeout_livestock_class_id = purchase.livestock_class_id;
      }
      if (this.closeout_purchases.length == 0) {
        let msg = "closeout";
        if (command == 0) msg = "calculate values";
        this.$message({
          type: "info",
          message: `Please select one or more trades to ${msg}.`,
        });
        return;
      }

      if (command == 2) {
        this.invoice_type_id = command;
        this.payoutCloseoutMT();
      } else if (command == 1) {
        this.invoice_type_id = command;
        this.refinanceCloseoutMT();
      } else if (command == 0) {
        this.valuesToRefinanceCloseoutMT();
      } else if (command == -1) {
        this.updateTermModalShow = true;
      }
    },
    getDaysUntilExpiryMT(date, showRealFigure = false) {
      let days = 0;
      if (date)
        days = moment(moment(date).startOf("day")).diff(
          moment(moment().startOf("day")),
          "days"
        );

      if (days < 0 && !showRealFigure) days = 0;

      return days;
    },
    downloadHeadsMT(purchase, off_pic = false) {
      let data = { purchase_id: purchase.id, off_pic: off_pic ? 1 : 0 };
      axios
        .get(`/api/v2/closeout-purchases/export-rfids`, {
          params: data,
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          const timestamp = moment().format("YYMMDDDD");
          link.setAttribute(
            "download",
            `purchase_purchase_assets_${timestamp}.csv`
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally((_) => {
          //this.export_loading = false;
        });
    },

    //for nlis page
    selectBusinessNlisMT(val, nlisRecord) {
      let purchase = nlisRecord.purchase_asset.purchase;
      if (this.closeout_group_ids.length == 1 && val.target.checked) {
        this.closeout_purchases = [];
      }
      if (val.target.checked && !this.closeout_business) {
        this.closeout_business = purchase.business;
        this.closeout_livestock_class_id = purchase.livestock_class_id;
      }

      if (val.target.checked) {
        let purchaseData = this.getPurchaseDataMT(purchase);
        this.closeout_purchases.push(purchaseData);
      } else {
        this.closeout_purchases = this.closeout_purchases.filter(
          (p) => p.id != purchase.id
        );
      }
      if (this.closeout_group_ids.length == 0) {
        this.clearCloseoutMT();
      }
    },
    validateBusinessNlisMT(purchase) {
      if (this.closeout_group_ids.length > 0 && this.closeout_business) {
        if (
          purchase.business_id != this.closeout_business.id ||
          purchase.livestock_class_id != this.closeout_livestock_class_id
        )
          return true;
      }
      if (
        purchase.latest_balance_batch &&
        purchase.latest_balance_batch.status != 2
      ) {
        return true;
      }
      return false;
    },
    closeoutPurchaseNlisMT(command, purchase = null) {
      if (purchase) {
        let purchaseData = this.getPurchaseDataMT(purchase);
        this.closeout_purchases = [purchaseData];
        // this.store_closeout_purchase_ids = [purchase.id];
        this.closeout_business = purchase.business;
        this.closeout_livestock_class_id = purchase.livestock_class_id;
      }
      if (this.closeout_purchases.length == 0) {
        let msg = "closeout";
        if (command == 0) msg = "calculate values";
        this.$message({
          type: "info",
          message: `Please select one or more trades to ${msg}.`,
        });
        return;
      }
      if (command == 2) {
        this.invoice_type_id = command;
        this.payoutModalShow = true;
        this.animals_sold = true;
      } else if (command == -1) {
        this.updateTermModalShow = true;
      }
    },
  },
};
